var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 132,
    viewBox: "0 0 128 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Idea",
    filter: "url(#filter0_d_90_649)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M70.8502 57.4977C70.7398 56.9985 70.2465 56.683 69.7465 56.7936C69.2473 56.904 68.9321 57.3981 69.0425 57.8974C69.2667 58.9116 69.3803 59.9567 69.3803 61.0036C69.3803 64.2452 68.3148 67.324 66.2991 69.9069C63.1931 73.8865 61.4076 78.6887 61.1267 83.8097H60.302H59.4566V81.8512C59.4566 81.3032 59.1156 80.8342 58.6351 80.6427L60.3661 67.7664C60.4193 67.3694 60.2538 66.9727 59.9345 66.7316C59.74 66.5846 59.5081 66.507 59.2642 66.507C59.1096 66.507 58.9593 66.5385 58.8192 66.6L56.6607 67.5431L54.4361 66.5956C54.1347 66.4676 53.7811 66.4811 53.4921 66.6304L51.6477 67.5804L49.1511 66.5867C48.7906 66.442 48.3618 66.5025 48.054 66.7422C47.7443 66.9837 47.5841 67.3759 47.6361 67.7667L48.3321 72.9437C48.4003 73.4505 48.867 73.8055 49.373 73.7379C49.8797 73.6697 50.2353 73.2037 50.1672 72.697L49.6397 68.7737L51.3547 69.4562C51.6035 69.5552 51.883 69.5416 52.121 69.4191L54.0311 68.4352L56.3028 69.4027C56.5373 69.5026 56.8027 69.5014 57.0362 69.3994L58.3561 68.8226L56.7793 80.55H51.2226L50.7571 77.0871C50.689 76.5804 50.223 76.2255 49.7162 76.293C49.2095 76.3611 48.8538 76.8271 48.922 77.3337L49.3668 80.6427C48.8863 80.8342 48.5453 81.3032 48.5453 81.8512V83.8097H47.7001H46.8778C46.6065 78.7977 44.7847 73.95 41.6002 69.7734C39.6618 67.2312 38.632 64.2149 38.6217 61.0504C38.5957 52.907 45.4448 46.235 53.8896 46.1775C53.9266 46.1772 53.963 46.1771 53.9998 46.1771C59.6645 46.1771 64.8467 49.156 67.5431 53.9702C67.793 54.4162 68.3572 54.5756 68.8032 54.3255C69.2493 54.0757 69.4083 53.5115 69.1586 53.0655C66.1345 47.6661 60.3346 44.3256 54 44.3256C53.9591 44.3256 53.918 44.3257 53.8771 44.326C44.4151 44.3905 36.741 51.8957 36.7703 61.0564C36.782 64.6277 37.943 68.0302 40.128 70.896C43.1367 74.8422 44.8355 79.4251 45.0407 84.1495C45.0778 84.9972 45.781 85.6612 46.6415 85.6612H46.7745V93.3347C46.7745 95.0006 47.7736 96.4774 49.32 97.097C50.8152 97.6962 52.3901 98 54.001 98C55.6118 98 57.1867 97.6962 58.6821 97.097C60.2285 96.4774 61.2276 95.0005 61.2276 93.3347V85.6612H61.3628C62.2222 85.6612 62.9252 84.9989 62.9632 84.1532C63.1796 79.3207 64.8378 74.7882 67.7583 71.046C70.0306 68.1345 71.2316 64.662 71.2316 61.0036C71.2317 59.8225 71.1033 58.643 70.8502 57.4977ZM50.3968 82.4015H57.6052V83.8097H50.3968V82.4015ZM48.6258 85.6612H59.3762V87.5701H48.6258V85.6612ZM48.6258 89.4216H59.3762V90.6765H48.6258V89.4216ZM59.3763 93.3347C59.3762 94.2396 58.8335 95.0419 57.9935 95.3785C56.7182 95.8895 55.375 96.1486 54.0011 96.1486C52.6272 96.1486 51.284 95.8895 50.0087 95.3785C49.1687 95.0419 48.626 94.2396 48.626 93.3347V92.528H59.3763V93.3347Z",
    fill: "#FDE047"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M83.0223 63.0222H77.2263C76.7149 63.0222 76.3005 63.4367 76.3005 63.948C76.3005 64.4592 76.7149 64.8737 77.2263 64.8737H83.0223C83.5337 64.8737 83.948 64.4592 83.948 63.948C83.948 63.4367 83.5335 63.0222 83.0223 63.0222Z",
    fill: "#FDE047"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M30.7739 63.0222H24.9778C24.4664 63.0222 24.052 63.4367 24.052 63.948C24.052 64.4592 24.4664 64.8737 24.9778 64.8737H30.7739C31.2853 64.8737 31.6996 64.4592 31.6996 63.948C31.6996 63.4367 31.2853 63.0222 30.7739 63.0222Z",
    fill: "#FDE047"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M75.1764 83.8151L71.0779 79.7167C70.7163 79.3552 70.1303 79.3552 69.7687 79.7167C69.4072 80.0782 69.4072 80.6644 69.7687 81.0259L73.8672 85.1242C74.0479 85.305 74.2849 85.3954 74.5218 85.3954C74.7587 85.3954 74.9957 85.305 75.1764 85.1242C75.5379 84.7627 75.5379 84.1766 75.1764 83.8151Z",
    fill: "#FDE047"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M38.2312 46.87L34.1329 42.7715C33.7712 42.41 33.1852 42.41 32.8236 42.7715C32.4621 43.133 32.4621 43.7191 32.8236 44.0806L36.922 48.1791C37.1027 48.3599 37.3396 48.4502 37.5766 48.4502C37.8135 48.4502 38.0505 48.3599 38.2312 48.1791C38.5927 47.8176 38.5927 47.2315 38.2312 46.87Z",
    fill: "#FDE047"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M75.1764 42.7716C74.8149 42.41 74.2289 42.41 73.8672 42.7715L69.7687 46.87C69.4072 47.2315 69.4072 47.8176 69.7687 48.1791C69.9494 48.3599 70.1863 48.4503 70.4233 48.4503C70.6602 48.4503 70.8972 48.3599 71.0779 48.1791L75.1764 44.0808C75.5379 43.7193 75.5379 43.1331 75.1764 42.7716Z",
    fill: "#FDE047"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M38.2312 79.7167C37.8696 79.3552 37.2836 79.3552 36.922 79.7167L32.8236 83.8151C32.4621 84.1766 32.4621 84.7627 32.8236 85.1242C33.0044 85.305 33.2414 85.3954 33.4782 85.3954C33.7151 85.3954 33.9521 85.305 34.1329 85.1242L38.2312 81.0259C38.5927 80.6644 38.5927 80.0782 38.2312 79.7167Z",
    fill: "#FDE047"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M54 34C53.4886 34 53.0742 34.4145 53.0742 34.9258V40.7217C53.0743 41.233 53.4887 41.6475 54 41.6475C54.5113 41.6475 54.9257 41.233 54.9257 40.7217V34.9258C54.9257 34.4145 54.5113 34 54 34Z",
    fill: "#FDE047"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_90_649",
    x: -2,
    y: 0,
    width: 132,
    height: 132,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 0.878431 0 0 0 0 0.278431 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_90_649"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_90_649",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdea);
export default __webpack_public_path__ + "static/media/Idea.d4b482cd001e48c19af2229275aac6a3.svg";
export { ForwardRef as ReactComponent };